package com.anjuros.website.redesign.sections.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.BlogMetaStyle
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** Topic (optional), publish date and reading time of an article, in one line. */
@Composable
fun BlogMeta(guide: RdBlogGuide, showTopic: Boolean = true) {
    P(BlogMetaStyle.toModifier().toAttrs()) {
        if (showTopic) Span { Text(LocalText(guide.topic)) }
        Span {
            RdTag("time", Modifier.attrsModifier { attr("datetime", guide.published) }) { Text(guide.card.dateDisplay) }
        }
        Span { Text(blogReadTime(guide.card)) }
    }
}
